export default {
  home: {
    hello: "Hello,",
    description: "Control panel",
    advice: {
      name: "Tip 1",
      title: "Practical guide to financial sustainability in NGOs",
      description: "The first part of the text is a conceptualisation.",
      more: "View more"
    },
    tools: {
      title: "Your tools",
      web: "Design your website",
      shop: "Create your store",
      events: "Organize an event",
      blog: "Blog",
      reviews: "Reviews",
      bookings: "Bookings",
      projects: "Create portfolio",
      services: "Create services"
    },
    ybs: "With the support of"
  }
};
